var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_37_2056",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 55,
    height: 55
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.174805,
    width: 54.4762,
    height: 54.4762,
    fill: "url(#pattern0_37_2056)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_37_2056)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.174805,
    width: 54.4762,
    height: 54.4762,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_37_2056",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_37_2056",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_37_2056",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACyElEQVR4nO2dPWtUQRSGH0VWwc7CRhAsJRFstElhJYgSsBAbLQRBG8FGSGMh9i6Jn3/CL2y00HQq2FhEG8FOMGhlElQkOnJhiiDu7uy9mZmzM+8Db7NwD5zz7M7u3bs7F4QQQgghhBBCCCGECOcAsAC8A9YAV3jWfK/zwHTOwW8H7gK/DQzFZUrT+x2gl2P4iwYG4IzkRWoJ9ww07Yzldso1v+Zlxw3IOjCVQsCCgWad0fRTCHhvoFFnNEspBKwaaNQZzUoKAbmbdMYjAUhA1YlO7gad8UgAEjA0L4ErwElgFrjsH8s9uOIF/ABOD6l7zp9N5h5gsQLOB9S+amCARQr4BGwNqL0T+G5giMUJeDhG/TcGhlicgPtj1H9tYIjFCfgwxoWeFQNDLE5Ak+MBtS8ZGGCxAr4AB4fUnfUfVXMPsFgBTX76y5nHgP1eyFngCfDHwPCKF1BDopO7QWc8EoAEVJ3o5G7QGY9JAZ83sf6pwDq3NhzzC3gEXAQOAbv9Sd8OYB9wBngqAXEEPAD2Bh5zAliWADZNwPUW/TW/eP4qAXQWcJT2NK8ECaCbgK48lgCyCjgiAWQVsAX4KAF0FrDNr+lz/hvXkEujXf4HEZ1JErAHePvP8c/G+DfLBQmgtYBmCXk1oMa1wBqHJYDWAmaG1Fj2gkbRnCVLAO0EzI2o0wx3FLskgNYC+iPqNMtLyBu4BND9y7j/ZSZSv9GRACQgBAmQgDhIABIQggRIQBwkAAkIQQIkIA4SgASEIAESEAcJQAJCkIBKE53cDTrjkQAkoOpEJ3eDzngkAAmoOtHJ3aAznuho41YG5lsKAdq6mLxbF88baNQZzY0UAqYL2VzPTer29fjbduRu2BnLTRLS87ftyN20M5LnOe4j0/O37ah5OVr3z/zkw9/IlP8p+FIlH1FXfa/9lGu+EEIIIYQQQgghhGDi+Qt+gjseADL8EgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.364a127fc07c9ebcd1d25e16a6079716.svg";
export { ForwardRef as ReactComponent };